import { useAuth } from '@opendoor/auth-fe';

import { EntryComponent } from 'cms/entries/entries';

import { ILpComponentCalculator } from 'declarations/contentful';

import { feeInputFields } from './constants/home-sale-calculator';
import { feeInputFields as comparisonCalculatorInputFields } from './constants/net-proceeds-comparison-calculator';
import HomeSaleCalculator from './HomeSaleCalculator';
import MortgageCalculator from './MortgageCalculator';
import NetProceedsComparisonCalculator from './NetProceedsComparisonCalculator';
import { LandingPageSectionContainer } from './shared/Container';

type CalculatorType = 'Home Rate Calculator' | 'Mortgage Calculator' | 'Builder Calculator';

const getCalculatorToRender = (
  calculatorType: CalculatorType,
  disclosureText: string | undefined,
  isLoggedIn: boolean,
) => {
  switch (calculatorType) {
    case 'Mortgage Calculator':
      return <MortgageCalculator disclosureText={disclosureText} />;
    case 'Home Rate Calculator':
      return (
        <HomeSaleCalculator
          disclosureText={disclosureText}
          feeInputFields={feeInputFields}
          isLoggedIn={isLoggedIn}
        />
      );
    case 'Builder Calculator':
      return (
        <NetProceedsComparisonCalculator
          disclosureText={disclosureText}
          feeInputFields={comparisonCalculatorInputFields}
        />
      );
  }

  return null;
};

export const RenderCalculator = (entry: ILpComponentCalculator) => {
  const {
    fields: { calculatorType, disclosureText },
  } = entry;
  const { authentication } = useAuth();
  const isLoggedIn = authentication.state === 'authenticated';
  return calculatorType === 'Builder Calculator' ? (
    getCalculatorToRender(calculatorType, disclosureText, isLoggedIn)
  ) : (
    <LandingPageSectionContainer>
      {getCalculatorToRender(calculatorType, disclosureText, isLoggedIn)}
    </LandingPageSectionContainer>
  );
};

const Calculator: EntryComponent<ILpComponentCalculator> = {
  render: RenderCalculator,
};

export default Calculator;
